<template lang="">
  <div id="copyright">
    <div class="copyright">
      <div class="blogo">
        <a href="/" target="_blank">
          <img :src="footerList.site_logo">
        </a>
      </div>
      <p class="p0" style="margin-top: 0pt; margin-bottom: 0pt">
        <font face="Arial" size="2">&nbsp; &nbsp;{{footerList.company_name}}</font>
      </p>
      <p class="p0" style="margin-top: 0pt; margin-bottom: 0pt">
        <span style="font-size: small;">&nbsp; &nbsp; &nbsp;总部：{{footerList.company_address}}</span>
      </p>
      <p class="p0" style="margin-top: 0pt; margin-bottom: 0pt">
        <font face="Arial" size="2">&nbsp; &nbsp; </font>
        <font face="Arial" size="2">电&nbsp;话：{{footerList.contact_phone}}&nbsp; &nbsp;</font>
        <span style="font-family: Arial; font-size: small;">传&nbsp;真：{{footerList.company_fax}}</span>
      </p>
      <p class="p0" style="margin-top: 0pt; margin-bottom: 0pt">
        <font face="Arial" size="2">工厂：{{footerList.factory_address}}</font>
      </p>

      <p class="p0" style="margin-top: 0pt; margin-bottom: 0pt">
        <span
          style="font-family: 微软雅黑; font-size: 9pt">Copyright&nbsp;2024&nbsp;ZHONGLEI&nbsp;GROUP.&nbsp;Power&nbsp;by&nbsp;</span>
        <span style="font-family: 微软雅黑; color: rgb(0,0,255); font-size: 9pt"><a target="_blank"
            href="http://www.oodow.com/">oodow</a></span>
        <span style="font-family: 微软雅黑; font-size: 9pt">.&nbsp;</span>
        <span style="font-family: 微软雅黑; color: rgb(0,0,255); font-size: 9pt"><a target="_blank"
            href="http://www.miitbeian.gov.cn/">{{footerList.icp_number}}</a>&nbsp;</span>
        <span style="font-family: 微软雅黑; font-size: 9pt">
          <o:p></o:p>
        </span>
      </p>
      <div class="blogo2">
        <a href="http://www.shzljt.com/" target="_blank">
          <img :src="footerList.site_logo2">
        </a>
      </div>
      
      <div id="search">
        <form id="search_p" @submit.prevent="" method="get">
          <input name="keyword" class="search" value="Search" type="text" v-model="name">
          <input name="button" class="button" value=" " type="submit" @click="btnSubmit()">
          <input name="a" value="search" type="hidden">
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        name: '',
        footerList: []
      }
    },
    mounted() {
      this.getFooter()
    },
    methods: {
      async getFooter() {
        const res = await this.$request.post('seo/getPaginate')
        if (res.data.code === 0) {
          this.footerList = res.data.data.data[0]
        }
      },
      btnSubmit() {
        this.$router.push({ path: '/search', query: { name: this.name } })
      }
    },
  }
</script>
<style lang="css" scoped>
  .copyright a:last-child img {
    width: 100%;
  }
  .blogo2{
    width: 180px;
    height: 62px;
    position: absolute;
    right: 160px;
    top: 10px;
  }
</style>